import React from 'react';

import { MDText } from 'i18n-react';

import { TickIcon } from '@motorway/mw-highway-code';
import { SIZE } from '@motorway/mw-highway-code/enums';

import LocalTexts from '../../../../landingPageTexts.json';

import styles from './HeroUspTicker.scss';

const LocalT = new MDText(LocalTexts);

const t = (key: string, args?: Record<string, string | React.ReactNode>) => `${LocalT.translate(key, args)}`;

const TICKER_POINTS = [
  t('landingSellMyCarsView.hero.UspTicker.0'),
  t('landingSellMyCarsView.hero.UspTicker.1'),
  t('landingSellMyCarsView.hero.UspTicker.2'),
];

export const HeroUspTicker = () => (
  <section className={ styles.component }>
    <ul>
      {TICKER_POINTS.map((item) => (<li key={item}>
        <TickIcon
          filled={ false }
          size={SIZE.XSMALL}
        />
        <span>{item}</span>
      </li>))}
    </ul>
  </section>
);
